/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-09 11:32:22
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-09 11:34:54
 * @name: 设置浏览器标签标题
 * @Description: 设置浏览器标签标题
 * @FilePath: \backstage\src\utils\set-page-title.js
 * @Author: DESKTOP-1QU67QM
 */
import defaultSettings from '@/settings'

const title = defaultSettings.title || '售前售后管理系统'

export default function setPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
